/* Round 132 (owner, 21 Oct 2026): Spend and Save bar above Add To Cart on pdp-k product pages.
   Spec: workspace/theme-copy-2026-10-15/spend-save-bar/spec.md (the "clean animated" mockup).
   Total = cart subtotal + this page's current selection (the amount on the Add To Cart button).
   The picker (pdp-k.js or pdp-fa-sets.js) sends that selection with a "pk:selection" event on its .pk
   article and keeps the last one on article._pkSel, so a bar that starts later still has it.
   The tiers come from the section settings (Free shipping at, Tier 1-3 at and reward). */
(function () {
  if (customElements.get('pk-ss-bar')) return;
  var POS = [10, 40, 70, 100];
  /* Round 158: prices in the shopper's currency. The section writes {{ 123456789 | money }} (Shopify's format for
     that currency, e.g. "$1,234,567.89", "£1,234,567.89" or "€1.234.567,89"); the symbol, separators and
     decimals come from it. Whole amounts show without decimals (Round 98). */
  function pkMoneyFormat(sample) {
    sample = String(sample || '').replace(/<[^>]*>/g, '');
    var m = /1(\D?)234(\D?)56(?:7(\D)89|8)(?!\d)/.exec(sample);
    if (!m) return null;
    return { pre: sample.slice(0, m.index), post: sample.slice(m.index + m[0].length), thou: m[1], dec: m[3] || '', cents: !!m[3] };
  }
  function pkMoneyOut(c, f, keepDec) {
    var n = Math.round(c), neg = n < 0;
    n = Math.abs(n);
    var parts = (n / 100).toFixed(f.cents && (keepDec || n % 100 !== 0) ? 2 : 0).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, f.thou);
    return (neg ? '-' : '') + f.pre + parts.join(f.dec) + f.post;
  }
  var ICON = {
    truck: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6.5h10.5v9H3zM13.5 9.5h4l3 3.2v2.8h-7"/><circle cx="7" cy="17" r="1.7"/><circle cx="17" cy="17" r="1.7"/></svg>',
    tag: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 12.2V4.5h7.7l9.3 9.3-7.7 7.7z"/><circle cx="8" cy="9" r="1.4"/></svg>',
    gift: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 10h16v3.5H4zM5.5 13.5h13V20h-13zM12 10v10M12 10c-1.5-3.5-5.5-4-5.5-1.5S10 10 12 10zm0 0c1.5-3.5 5.5-4 5.5-1.5S14 10 12 10z"/></svg>'
  };
  var lastAct = 0;
  ['pointerdown', 'keydown', 'change'].forEach(function (n) { document.addEventListener(n, function () { lastAct = Date.now(); }, true); });
  var reduced = function () { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; };
  /* Round 136: Title Case display text ("$10 Off", "Free Ship"). */
  var tc = function (s) { return String(s).replace(/(^|[\s-])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); }); };
  /* Owner 21 Oct ("can try add a confetiti emoji?"): 🎉 after the unlock lines only (owner: "put the emoji at the end of the text"), hidden from screen readers. */
  var PARTY = '<span class="pk-ss__party" aria-hidden="true">\uD83C\uDF89</span>';
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  /* Round 168: a cart line with a Wash & Swap Pack price (line discount title has "pack", or 20OFF, 25OFF or
     "MSB Deal kv"; discount codes don't count). Since 23 Oct 2026 Spend & Save stacks on pack prices, so this
     no longer changes the bar; the cart subtotal it counts is already after pack prices. */
  var PACK_RE = /pack|20OFF|25OFF|MSB Deal kv/i;
  var packLine = function (it) {
    var al = it.line_level_discount_allocations || [];
    if (al.length) return al.some(function (a) { var d = a.discount_application || {}; return d.type !== 'discount_code' && PACK_RE.test(d.title || ''); });
    return (it.discounts || []).some(function (d) { return PACK_RE.test(d.title || ''); });
  };
  /* One cart subtotal for every bar on the page. Refreshed after anything that changes the cart. */
  var cart = { sub: null, subs: [] };
  var loadCart = function () {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart.sub = c.items_subtotal_price || 0; cart.pack = (c.items || []).some(packLine); cart.subs.forEach(function (f) { f(); }); })
      .catch(function () { if (cart.sub === null) { cart.sub = 0; cart.subs.forEach(function (f) { f(); }); } });
  };
  var t;
  var soon = function () { clearTimeout(t); t = setTimeout(loadCart, 250); };
  document.addEventListener('cart:updated', soon);
  if (window.EventBus && typeof window.EventBus.on === 'function') { try { window.EventBus.on('cart:changed', soon); } catch (e) {} }
  /* The cart drawer changes quantities with fetch; watch for those calls without changing them. */
  if (window.fetch && !window.fetch._pkSS) {
    var f0 = window.fetch;
    var wrapped = function (input) {
      var p = f0.apply(this, arguments);
      try {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)(\.js)?/.test(u)) p.then(soon, soon);
      } catch (e) {}
      return p;
    };
    wrapped._pkSS = true;
    window.fetch = wrapped;
  }

  class PkSsBar extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      try { this.T = JSON.parse(this.querySelector('[data-ss-tiers]').textContent); } catch (e) { return; }
      this.T = this.T.filter(function (x) { return x.at > 0; }).slice(0, 4);
      /* Round 158: tiers are in US dollars; outside the US, convert them at Shopify's rate for the shopper's currency. */
      var rate = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate) || 1;
      if (rate !== 1) this.T.forEach(function (x) { x.at = x.at * rate; });
      var ms = this.querySelector('[data-ss-money]');
      this.mf = ms ? pkMoneyFormat(ms.getAttribute('data-ss-money')) : null;
      if (!this.T.length) { this.hidden = true; return; }
      this.msg = this.querySelector('[data-ss-msg]');
      this.box = this.querySelector('.pk-ss');
      this.fill = this.querySelector('[data-ss-fill]');
      this.rail = this.querySelector('[data-ss-rail]');
      this.note = this.querySelector('[data-ss-note]');
      this.drawStops();
      this.sel = { total: 0, hints: [] };
      this.prev = null;
      var art = this.art = this.closest('.pk') || document;
      if (art._pkSel) this.sel = art._pkSel;
      art.addEventListener('pk:selection', function (e) { self.sel = e.detail || self.sel; self.update(); });
      cart.subs.push(function () { self.update(); });
      if (cart.sub === null && !cart.loading) { cart.loading = true; loadCart(); } else self.update();
    }
    pos(i) { return this.T.length === 4 ? POS[i] : Math.round((i + 1) / this.T.length * 100); }
    drawStops() {
      var self = this;
      this.stops = this.T.map(function (x, i) {
        var s = document.createElement('div');
        s.className = 'pk-ss__stop';
        s.style.left = self.pos(i) + '%';
        s.innerHTML = '<span class="pk-ss__dot">' + ICON.gift + '</span>' +
          '<span class="pk-ss__lab"><span class="pk-ss__name"><span class="pk-ss__long">' + esc(tc(x.label)) + '</span><span class="pk-ss__short">' + esc(tc(x.short || x.label)) + '</span></span>' +
          '<span class="pk-ss__at">' + esc(self.atLabel(x.at)) + '</span></span>';
        self.rail.appendChild(s);
        return s;
      });
    }
    /* Piecewise: $0 to the first tier is the first stop's share, then each tier gap is an equal part. */
    pct(total) {
      var T = this.T, prevAt = 0, prevPos = 0;
      for (var i = 0; i < T.length; i++) {
        var at = T[i].at * 100, p = this.pos(i);
        if (total < at) return prevPos + (total - prevAt) / (at - prevAt) * (p - prevPos);
        prevAt = at; prevPos = p;
      }
      return 100;
    }
    money(c) { return this.mf ? pkMoneyOut(c, this.mf, true) : '$' + (c / 100).toFixed(2); }
    /* Round 160: a stop's amount in the shopper's currency, whole units ("$100", "£76", "€91"). */
    atLabel(at) { var n = Math.round(at); return this.mf ? pkMoneyOut(n * 100, this.mf, false) : '$' + n; }
    update() {
      if (cart.sub === null) return;
      /* Just added to the cart: that selection is now in the cart subtotal, so it isn't counted twice. It counts
         again as soon as the shopper changes it (new key). */
      var added = this.sel.key && this.art && this.art._pkAdded === this.sel.key;
      var T = this.T, total = cart.sub + (added ? 0 : Math.max(0, Math.round(this.sel.total || 0)));
      /* Spend & Save stacks on pack prices (owner, 23 Oct 2026: "I want it to be stacked actually"), so every stop counts. */
      var pack = false;
      var on = function (i) { return !pack || T[i].icon === 'truck'; };
      if (this.note) this.note.hidden = !pack;
      if (this.box) this.box.classList.toggle('is-pack', pack);
      var next = -1;
      for (var i = 0; i < T.length; i++) { if (on(i) && total < T[i].at * 100) { next = i; break; } }
      var reached = next === -1 ? T.length : next;

      /* QA 21 Oct: "unlocked", the pop, the flash and the floating amount only follow a shopper action (a tap, key
         or change in the last 4s), never the page filling in on load. */
      var prev = this.prev, act = Date.now() - lastAct < 4000 && prev !== null;
      var crossed = [];
      if (act && total > prev) T.forEach(function (x, i) { if (on(i) && prev < x.at * 100 && total >= x.at * 100) crossed.push(i); });
      /* Owner 21 Oct ("I just want one line for the text part"): a newly reached reward shows "{reward} unlocked"
         on its own for 2.5s, then the message for the next stop. With reduced motion it goes straight to that.
         The cover hint ("one back cover gets you there") is gone. */
      var self = this;
      if (crossed.length && !reduced()) {
        this.unl = crossed[crossed.length - 1];
        clearTimeout(this._unlT);
        this._unlT = setTimeout(function () { self.unl = null; self.update(); }, 2500);
      } else if (this.unl != null && (total < T[this.unl].at * 100 || (total !== prev && !crossed.length))) {
        this.unl = null;
        clearTimeout(this._unlT);
      }

      /* Owner 21 Oct: Title Case on the message line, like the Add To Cart button and the announcement bar. */
      var tc = function (s) { return String(s).replace(/(^|\s)([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); }); };
      var html;
      if (this.unl != null) {
        html = '<b>' + esc(tc(T[this.unl].done)) + ' Unlocked</b>' + PARTY;
      } else if (next === -1 && pack) {
        html = '<b>Pack Price Applied + Free Shipping Unlocked</b>' + PARTY;
      } else if (next === -1) {
        var top = T[T.length - 1], ship = T.find(function (x) { return x.icon === 'truck'; });
        html = '<b>' + esc(tc(top.msg)) + (ship && ship !== top ? ' + ' + esc(tc(ship.msg)) : '') + ' Unlocked</b>' + PARTY;
      } else {
        html = 'Only <b>' + this.money(T[next].at * 100 - total) + '</b> Away From <b>' + esc(tc(T[next].msg)) + '</b>';
      }
      this.msg.classList.toggle('is-unlocked', html.indexOf(PARTY) !== -1);
      if (this.msg.innerHTML !== html) this.msg.innerHTML = html;

      var self = this;
      this.stops.forEach(function (s, i) {
        var state = !on(i) ? 'off' : (pack ? total >= T[i].at * 100 : i < reached) ? 'done' : i === reached ? 'next' : 'later';
        if (s.dataset.state !== state) {
          s.dataset.state = state;
          s.querySelector('.pk-ss__dot').innerHTML = state === 'done' ? ICON[T[i].icon] || ICON.tag : ICON.gift;
        }
      });
      var p = this.pct(total);
      this.fill.style.width = p + '%';

      this.prev = total;
      if (!act || prev === total || reduced()) return;
      this.float(total - prev, p);
      if (crossed.length) {
        crossed.forEach(function (i) {
          {
            var s = self.stops[i];
            s.classList.remove('is-pop'); void s.offsetWidth; s.classList.add('is-pop');
            self.box.classList.remove('is-flash'); void self.box.offsetWidth; self.box.classList.add('is-flash');
            clearTimeout(s._popT); s._popT = setTimeout(function () { s.classList.remove('is-pop'); }, 600);
            clearTimeout(self._flashT); self._flashT = setTimeout(function () { self.box.classList.remove('is-flash'); }, 800);
          }
        });
      }
    }
    float(diff, p) {
      var f = document.createElement('span');
      f.className = 'pk-ss__float' + (diff < 0 ? ' is-down' : '');
      f.textContent = (diff > 0 ? '+' : '−') + this.money(Math.abs(diff));
      f.style.left = Math.min(88, Math.max(8, p)) + '%';
      this.rail.appendChild(f);
      setTimeout(function () { f.remove(); }, 1100);
    }
  }
  customElements.define('pk-ss-bar', PkSsBar);
})();
